(() => {
  if (window.RemediuProductProofLoaded) return;

  window.RemediuProductProofLoaded = true;

  const SELECTOR = '[data-rp-product-proof]';
  const instances = new WeakMap();

  class RemediuProductProof {
    constructor(root, SwiperClass = window.Swiper) {
      this.root = root;
      this.SwiperClass = SwiperClass;
      this.swiper = null;
      this.blockCount = Number.parseInt(root.dataset.blockCount, 10) || 0;
      this.mobileSlides = Number.parseFloat(root.dataset.mobileSlides) || 1.5;
      this.mobileGap = Number.parseInt(root.dataset.mobileGap, 10) || 16;
      this.arrowsEnabled = root.dataset.arrowsEnabled !== 'false';
      this.init();
    }

    init() {
      const slider = this.root.querySelector('.rp-product-proof__swiper');

      if (!slider || !this.SwiperClass || this.blockCount < 2) return;

      const nextButton = this.root.querySelector('.rp-product-proof__nav--next');
      const previousButton = this.root.querySelector('.rp-product-proof__nav--prev');
      const hasDesktopOverflow = this.blockCount > 3 && this.arrowsEnabled;

      this.swiper = new this.SwiperClass(slider, {
        a11y: {
          enabled: true,
          nextSlideMessage: 'Dovada sociala urmatoare',
          prevSlideMessage: 'Dovada sociala anterioara',
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        loop: false,
        navigation: {
          enabled: false,
          nextEl: nextButton,
          prevEl: previousButton,
        },
        observer: true,
        observeParents: true,
        slidesPerView: this.mobileSlides,
        spaceBetween: this.mobileGap,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            navigation: {
              enabled: hasDesktopOverflow,
            },
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }

    destroy() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  const mount = (root) => {
    if (!root || instances.has(root)) return;

    instances.set(root, new RemediuProductProof(root));
  };

  const unmount = (root) => {
    const instance = instances.get(root);

    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  };

  const mountWithin = (container = document) => {
    if (container.matches?.(SELECTOR)) mount(container);
    container.querySelectorAll?.(SELECTOR).forEach(mount);
  };

  window.RemediuProductProof = RemediuProductProof;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin());
  } else {
    mountWithin();
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    unmount(root);
  });
})();

